"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeTracking = initializeTracking;

var _publish = _interopRequireDefault(require("@insided/deprecated-components/tracker/publish"));

var _GlobalEventTracker = require("@insided/shared/services/GlobalEventTracker");

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

function fetcher(data) {
  var newEventData = Object.assign(data, {
    eventName: 'userevent',
    eventDetail: data.eventName
  });

  _publish.default.trackEvent('userevent', newEventData);
}

function initializeTracking() {
  var insidedData = {
    communityId: (0, _insidedDataStorage.getInsidedData)('communityId'),
    environment: (0, _insidedDataStorage.getInsidedData)('environment'),
    language: (0, _insidedDataStorage.getInsidedData)('language'),
    locale: (0, _insidedDataStorage.getInsidedData)('locale'),
    user: (0, _insidedDataStorage.getInsidedData)('user'),
    form: (0, _insidedDataStorage.getInsidedData)('form'),
    device: (0, _insidedDataStorage.getInsidedData)('device'),
    page: (0, _insidedDataStorage.getInsidedData)('page'),
    content: (0, _insidedDataStorage.getInsidedData)('content'),
    search: (0, _insidedDataStorage.getInsidedData)('search')
  };
  var globalEventTracker = new _GlobalEventTracker.GlobalEventTracker(fetcher, (0, _globals.default)('environment') === 'development', insidedData);
  globalEventTracker.startTracking(['click', 'keydown']);
}